import router from '@/core/router.js';
import request from '@/utilities/request';
import { SIGNINTYPE, hashData } from '@/utilities/index';

export default {
  async checkAccount({ state }, requestBody) {
    let recaptchaToken = '';

    try {
      recaptchaToken = await state.recaptcha.execute('checkAccount');
    
    } catch (error) {
      // ignore
    }

    return request.post('/signin/module.php/tmauth/checkaccount', {
      recaptchaToken,
      ...requestBody,
    });
  },
  async signInAuth({ commit, dispatch, state, getters }, { userdata, signInForm }) {
    commit('ableToSignIn', false);
    commit('setEmailError', '');
    commit('setPhoneError', '');

    let recaptchaToken = '';

    try {
      recaptchaToken = await state.recaptcha.execute('signIn');
    } catch (error) {
      // ignore
    }

    request
      .post('/signin/module.php/tmauth/usersigninauth', {
        recaptchaToken,
        ...userdata,
      })
      .then((res) => {
        if (state.counter) {
          window.clearInterval(state.counter);
          commit('setCounter', null);
          sessionStorage.removeItem("emailOtpTime");
        }

        if (res.data.is_paid_account) {
          commit('setIsPaidAccount', res.data.is_paid_account);
        }

        if (res.data.is_email_verified) {
          commit('setIsEmailVerified', res.data.is_email_verified);
        }

        if (res.data.consumer_account_id) {
          const caid = res.data.consumer_account_id.split('.')[0];
          commit('setCaid', caid, { root: true });
        }

        if (res.data.is_mfa_enable === '0') {
          if (state.signInType === SIGNINTYPE.email && getters.needEmailVerification) {
            router.push({ name: 'auth/signInVerifyEmail' });
            return;
          }

          dispatch(
            'triggerEvent',
            {
              eventName: `SignInSuccess`,
              addInfo: {
                Method: state.signInType,
              },
            },
            { root: true },
          );

          signInForm.submit();
        }

        if (res.data.is_mfa_enable === '1') {
          commit('setTwoFactor', {
            isTwoFactor: true,
            availableMethod: res.data.mfa_method,
            methodEnum: res.data.mfa_method_enum,
            userSms: `(+${res.data.sms_country_code}) ${res.data.sms_phone_number_mask}`,
            userEmail: res.data.email_mask,
          });

          dispatch('triggerEvent', { eventName: `PageView-${state.defaultMethod}` }, { root: true });

          if (state.defaultMethod === 'sms' || state.defaultMethod === 'email') {
            dispatch('sendMFACode', { method: state.defaultMethod });
          }
        }
      })
      .catch(async (e) => {
        console.log('invalid credential'); // for client integration
        commit('ableToSignIn', true);

        const errorMsg = userdata.password
          ? state.lang.incorrectEmailPassword
          : state.lang.incorrectCode;

        commit('setSignInErrMsg', errorMsg);

        // send tc event
        let hexAccount = '';
        const isReAuth = router.currentRoute.path.includes('re_auth');

        if (userdata.email) {
          hexAccount = isReAuth ? userdata.email : await hashData(userdata.email, 'SHA-256');
        } else {
          const smsAccount = `${userdata.sms_country_code}-${userdata.sms_phone_number}`;
          hexAccount = isReAuth ? smsAccount : await hashData(smsAccount, 'SHA-256');
        }

        dispatch(
          'triggerEvent',
          {
            eventName: `SignInFail`,
            addInfo: {
              http_code: e?.response?.status,
              current_account: hexAccount,
            },
          },
          { root: true },
        );
      });
  },
  async signUpAuth({ commit, state, dispatch, rootState }, { userdata, signUpForm }) {
    commit('setEmailError', '');
    commit('setPhoneError', '');
    commit('setSignUpErrMsg', '');

    let recaptchaToken = '';

    try {
      recaptchaToken = await state.recaptcha.execute('signUp');
    } catch (error) {
      // ignore
    }

    let signUpMethod;
    if (userdata.provider) {
      signUpMethod = userdata.provider;
    } else if (userdata.passwordless_otp_code) {
      signUpMethod = 'Phone';
    } else {
      signUpMethod = 'Email';
    }

    request
      .post('/signin/module.php/tmauth/createtmaccount', {
        recaptchaToken,
        lang: rootState.userLang,
        ...userdata,
      })
      .then((res) => {
        if (res.data.consumer_account_id) {
          const caid = res.data.consumer_account_id.split('.')[0];
          commit('setCaid', caid, { root: true });
        }

        dispatch(
          'triggerEvent',
          {
            eventName: `SignUpSuccess`,
            addInfo: {
              Method: signUpMethod,
            },
          },
          { root: true },
        );

        signUpForm.submit();
      })
      .catch((err) => {
        commit('setIsLoading', false);
        dispatch(
          'triggerEvent',
          {
            eventName: `SignUpFail`,
            addInfo: {
              Method: signUpMethod,
              http_code: err.response?.status,
            },
          },
          { root: true },
        );

        if (err.response?.status === 409) {
          const linkAuthMethod = err.response.data?.available_link_auth_method;
          if (linkAuthMethod && linkAuthMethod.includes('passwordless-sms')) {
            commit('setShowAccountLinkingNotice', true);
          } else {
            commit('setIsAccountDuplicated', true);
          }
        } else {
          commit('setSignUpErrMsg', rootState.lang.error_msg.common);
        }
      });
  },
  async passwordlessAccountLinking(
    { commit, dispatch, state, rootState },
    { userdata, signInForm },
  ) {
    commit('ableToSignIn', false);

    let recaptchaToken = '';

    try {
      recaptchaToken = await state.recaptcha.execute('passwordlessLinkAccount');
    } catch (error) {
      // ignore
    }

    request
      .post('/signin/module.php/tmauth/passwordlesslinkaccount', {
        ...userdata,
        recaptchaToken,
      })
      .then((res) => {
        if (res.data.is_mfa_enable === '1') {
          commit('setTwoFactor', {
            isTwoFactor: true,
            availableMethod: res.data.mfa_method,
            methodEnum: res.data.mfa_method_enum,
            userSms: `(+${res.data.sms_country_code}) ${res.data.sms_phone_number_mask}`,
            userEmail: res.data.email_mask,
          });

          dispatch('triggerEvent', { eventName: `PageView-${state.defaultMethod}` }, { root: true });

          if (state.defaultMethod === 'sms' || state.defaultMethod === 'email') {
            dispatch('sendMFACode', { method: state.defaultMethod });
          }
        } else {
          signInForm.submit();
        }
      })
      .catch(async (e) => {
        if (e.response?.data?.message === 'Invalid credential.') {
          console.log('invalid credential'); // for client integration
          commit('setSignInErrMsg', state.lang.incorrectEmailPassword);
        } else {
          commit('setSignInErrMsg', rootState.lang.error_msg.common);
        }

        commit('ableToSignIn', true);

        // send tc event
        const smsAccount = `${userdata.sms_country_code}-${userdata.sms_phone_number}`;
        const hexAccount = await hashData(smsAccount, 'SHA-256');

        dispatch(
          'triggerEvent',
          {
            eventName: `SignInFail`,
            addInfo: {
              http_code: e?.response?.status,
              current_account: hexAccount,
            },
          },
          { root: true },
        );
      });
  },
  async socialAccountLinking({ commit, state }, { password, signInForm }) {
    commit('ableToSignIn', false);

    let recaptchaToken = '';

    try {
      recaptchaToken = await state.recaptcha.execute('socialLinkAccount');
    } catch (error) {
      // ignore
    }

    request
      .post('/signin/module.php/tmauth/sociallinkaccount', {
        password,
        recaptchaToken,
      })
      .then(() => {
        signInForm.submit();
      })
      .catch(() => {
        console.log('invalid credential'); // for client integration
        commit('ableToSignIn', true);
        commit('setSignInErrMsg', state.lang.incorrectPassword);
      });
  },
};
